import { CodeV2 as Code } from '@/redux/apis/codes-api';
import { User } from '@/redux/apis/frontend-api';
import { FC, PropsWithChildren, createContext, useContext } from 'react';

// User context

export const userContext = createContext({
  user: {} as User,
});

export const useUser = () => useContext(userContext);

export const UserProvider: FC<
  PropsWithChildren<{
    user: User;
  }>
> = ({ user, children }) => {
  return (
    <userContext.Provider value={{ user }}>{children}</userContext.Provider>
  );
};

// Code context

export const codeContext = createContext({
  code: {} as Code,
});

export const useCode = () => useContext(codeContext);

export const CodeProvider: FC<
  PropsWithChildren<{
    code: Code;
  }>
> = ({ code, children }) => {
  return (
    <codeContext.Provider value={{ code }}>{children}</codeContext.Provider>
  );
};
